import he from 'he';
import { useState, useEffect } from 'react';

import { getActiveLang } from '@openclassrooms/translations';

import { ajaxGet } from 'Modules/ajax';
import browser from '@openclassrooms/utils/browser';

import errorMessages from '../constants/errorMessages';

export const fetchCsrf = async (route) => {
  const activeLang = getActiveLang();
  const regexp = /&amp;/g;
  const sanitizeUrl = (url) => url.replace(regexp, '&');

  const result = {
    token: undefined,
    targetPath: undefined,
    error: undefined,
    errorData: undefined,
  };

  const blockDurationInSecondsIfUnknown = 60 * 30;

  try {
    const { data } = await ajaxGet(`/${activeLang}${route}${browser.window.location.search}`);
    const targetPathUrl = data.targetPath;

    result.token = data.csrf;
    result.targetPath = regexp.test(targetPathUrl) ? sanitizeUrl(targetPathUrl) : targetPathUrl;
    result.error = data.error ? he.decode(data.error) : null;
  } catch (e) {
    if (e.status === 429) {
      const duration = Number(e.headers.get('retry-after')) || blockDurationInSecondsIfUnknown;
      result.error = errorMessages.TooManyAttempts;
      result.errorData = { duration };
    } else {
      result.error = errorMessages.InvalidCSRFToken;
    }
  }

  return result;
};

const useCsrf = (route) => {
  const [csrf, setCsrf] = useState({
    token: null,
    targetPath: null,
    error: null,
  });

  useEffect(() => {
    let isCancelled = false;

    const startFetch = async () => {
      const csrfData = await fetchCsrf(route);
      if (!isCancelled) {
        setCsrf(csrfData);
      }
    };

    startFetch();

    return () => {
      isCancelled = true;
    };
  }, [route]);

  return csrf;
};

export default useCsrf;
